import Request from '@hotmart-org-ca/request'

import './request'

class PlayerService {
  static getMuxstudioToken = (muxStudioId: string) => Request('get.muxstudio.token', { muxStudioId })
}

export default PlayerService
